var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "app-header navbar is-fixed-top",
      class: _vm.headerClass,
      attrs: { role: "navigation", "aria-label": "main navigation" },
    },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c("app-logo", {
            staticClass: "navbar-item",
            attrs: { width: "180", height: "40" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "navbar-menu" }, [
        _c(
          "div",
          { staticClass: "navbar-start" },
          [
            _c(
              "router-link",
              {
                staticClass: "navbar-item router-link",
                attrs: { to: _vm.homelink },
              },
              [_vm._v(" Home ")]
            ),
            _vm.dashboardlink
              ? _c(
                  "router-link",
                  {
                    staticClass: "navbar-item router-link",
                    attrs: { to: _vm.dashboardlink },
                  },
                  [_vm._v(" Dashboards ")]
                )
              : _vm._e(),
            _vm.chartslink
              ? _c(
                  "router-link",
                  {
                    staticClass: "navbar-item router-link",
                    attrs: { to: _vm.chartslink },
                  },
                  [_vm._v(" Charts ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "navbar-end" },
          [
            _c(
              "router-link",
              {
                staticClass: "navbar-item gtm-view-settings",
                attrs: { to: _vm.settingslink },
              },
              [
                _c("dc-icon", {
                  attrs: { icon: "cog", size: "lg", "fixed-width": "" },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.onClickOutside,
                    expression: "onClickOutside",
                  },
                ],
                staticClass: "navbar-item has-dropdown",
                class: { "is-active": _vm.active },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggle.apply(null, arguments)
                  },
                },
              },
              [
                _vm.currentUser !== null
                  ? _c(
                      "a",
                      { staticClass: "navbar-link" },
                      [
                        _c("avatar", {
                          staticClass: "header-avatar",
                          attrs: {
                            image: _vm.currentUser.image,
                            alt: _vm.fullName,
                            cropped: true,
                            size: "is-32x32",
                            "is-rounded": "",
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.fullName) + " "),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "navbar-dropdown" }, [
                  _c(
                    "span",
                    { on: { click: _vm.close } },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "navbar-item gtm-view-logged-in-user-profile",
                          attrs: { to: _vm.profilelink },
                        },
                        [
                          _c("dc-icon", {
                            staticClass: "route-icon",
                            attrs: { icon: "user", "fixed-width": "" },
                          }),
                          _vm._v("Profile "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "navbar-divider" }),
                  _c(
                    "a",
                    {
                      staticClass: "navbar-item gtm-log-out",
                      on: { click: _vm.logout },
                    },
                    [
                      _c("dc-icon", {
                        staticClass: "route-icon",
                        attrs: { icon: "sign-out-alt", "fixed-width": "" },
                      }),
                      _vm._v(" Logout "),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }